import React from "react";
import { useTimer } from "react-timer-hook";

const Timer = ({ startTime }) => {
  const startDate = new Date(startTime); // Fecha de inicio del estado
  const now = new Date(); // Hora actual

  // Configurar el temporizador

  // Calcular tiempo transcurrido
  // Calcular tiempo transcurrido en segundos
  const elapsedTimeInSeconds = Math.floor((now - startDate) / 1000);

  // Calcular horas, minutos y segundos
  const hours = Math.floor(elapsedTimeInSeconds / 3600);
  const minutes = Math.floor((elapsedTimeInSeconds % 3600) / 60);
  const seconds = elapsedTimeInSeconds % 60;

  // Renderizar tiempo en formato hh:mm:ss
  return (
    <span>
      {String(hours).padStart(2, "0")}:{String(minutes).padStart(2, "0")}:
      {String(seconds).padStart(2, "0")}
    </span>
  );
};

const AgentStatus = ({
  status = "UNKNOWN",
  statusStartTime = 0,
  number,
  queue,
}) => {
  return (
    <div className="flex items-center dark:text-white">
      {status}&nbsp;|&nbsp;
      <Timer startTime={statusStartTime} />
      {number && <>&nbsp;|&nbsp;{number}</>}
      {queue && <>&nbsp;|&nbsp;{queue.toUpperCase()}</>}
    </div>
  );
};

export default AgentStatus;
